import { PrayerStatuses, Unit } from "@/utils/enums";
import { PrayerParams } from "./prayer-api";

// Types
export type UserDetails = {
    unit: Unit;
    faculty: {
        name: string | undefined;
        id: string | undefined;
        facultyId: string | undefined;
    };
    department: {
        name: string | undefined;
        id: string | undefined;
        departmentId: string | undefined;
    };
    userId: string;
    roleId: string;
};

// Values
export const defaultStatusByUnit = {
    DEPARTMENT: PrayerStatuses.Initiated,
    FACULTY: PrayerStatuses.Raised,
    SBC: PrayerStatuses.Submitted,
    SENATE: PrayerStatuses.Submitted,
    SECRETARIAT: PrayerStatuses.Recommended,
};

// Utlity Functions
export const getDefaultPrayersFilter = (userDetails: UserDetails) => {
    const defaultParams: PrayerParams = {
        limit: 20,
        status: defaultStatusByUnit[userDetails.unit],
    };
    const departmentId = userDetails.department?.id;
    const facultyId = userDetails.faculty?.facultyId;

    if (userDetails.unit === Unit.Department && departmentId) {
        defaultParams.departmentId = departmentId;
    }

    if (userDetails.unit === Unit.Faculty && facultyId) {
        defaultParams.facultyId = facultyId;
    }

    if (userDetails.unit === Unit.Sbc && facultyId) {
        defaultParams.facultyId = facultyId;
    }

    if (userDetails.unit === Unit.Senate && facultyId) {
        defaultParams.facultyId = facultyId;
    }
    return defaultParams;
};
